import apiFactory from '@/api';
const aiVisibilityApi = apiFactory.get('aiVisibility');

import {
  SET_DOMAINS_LIST,
  SET_IS_AI_VISIBILITY_ENABLED,
  SET_IS_AI_VISIBILITY_DOMAINS_FETCHING,
} from '@/store/mutations';

export default {
  state: {
    domainsList: null,
    isAiVisibilityEnabled: false,
    isDomainsFetching: true,
  },
  mutations: {
    [SET_DOMAINS_LIST]: (state, payload) => (state.domainsList = payload),
    [SET_IS_AI_VISIBILITY_ENABLED]: (state, payload) => (state.isAiVisibilityEnabled = payload),
    [SET_IS_AI_VISIBILITY_DOMAINS_FETCHING]: (state, payload) => (state.isDomainsFetching = payload),
  },
  getters: {
    getAiVisibilityDomainsList: (state) => state.domainsList,
    getIsAiVisibilityEnabled: (state) => state.isAiVisibilityEnabled,
    getIsAiVisibilityDomainsFetching: (state) => state.isDomainsFetching,
  },
  actions: {
    async fetchAiVisibilityDoaminsList({ commit, getters }, payload = {}) {
      if (getters.isViewOnlyUser) {
        commit(SET_IS_AI_VISIBILITY_DOMAINS_FETCHING, false);

        return;
      }
      try {
        commit(SET_IS_AI_VISIBILITY_DOMAINS_FETCHING, true);
        const { searchTerm } = payload;
        const resp = await aiVisibilityApi.getDomainsList({
          search_term: searchTerm,
          per_page: 1000,
        });

        commit(SET_DOMAINS_LIST, resp.data?.data || []);

        return resp.data;
      } catch (e) {
        return null;
      } finally {
        commit(SET_IS_AI_VISIBILITY_DOMAINS_FETCHING, false);
      }
    },
    async deleteAiVisibilityDomain({ commit, getters }, payload) {
      try {
        await aiVisibilityApi.deleteDomain(payload);

        commit(
          SET_DOMAINS_LIST,
          getters.getAiVisibilityDomainsList.filter((item) => item.id !== payload),
        );

        return true;
      } catch (e) {
        return false;
      }
    },
    async addAiVisibilityDomain({ commit, getters }, payload) {
      try {
        const res = await aiVisibilityApi.addDomain({ domain: payload });
        const domains = getters.getAiVisibilityDomainsList ? getters.getAiVisibilityDomainsList : [];

        commit(SET_DOMAINS_LIST, [...domains, res.data.data]);

        return res.data.data;
      } catch (e) {
        return false;
      }
    },
    async fetchAiVisibilityDomainById(_nothing, payload) {
      try {
        const res = await aiVisibilityApi.getDomain(payload);

        return res.data.data;
      } catch (e) {
        return false;
      }
    },
    setIsAiVisibilityEnabled({ commit }, payload) {
      commit(SET_IS_AI_VISIBILITY_ENABLED, payload);
    },
    setIsAiVisibilityDomainsFetching({ commit }, payload) {
      commit(SET_IS_AI_VISIBILITY_DOMAINS_FETCHING, payload);
    },
  },
};
